import PopUpMultiSelect from './PopUpMultiSelect'

export { PopUpMultiSelect }
export default PopUpMultiSelect
